import React from 'react';
export function Footer() {
  return <footer className="bg-ink px-5 py-8 text-center" data-id="element-140" data-mp="19j53j40hsmi0">
      <p className="text-[12px] font-semibold uppercase tracking-[0.18em] text-white" data-id="element-141" data-mp="2082lvf464wit">
        Happy Parenting
      </p>
      <p className="mt-2 text-[11px] text-white/55" data-id="element-142" data-mp="2f3sall0qnnr8">
        © 2026 Happy Parenting · Terms · Privacy · Contact
      </p>
    </footer>;
}